// Publishes TypeScript exports to window.app.* globals required by 3 legacy JS files:
//   controllers/reporting/add_report_modal.js
//   controllers/reporting/add_tag_report_modal.js
//   directives/controls/navigation.js
// TODO: Remove this file when those JS files are replaced in React Phase 6.

import { DataGrid } from './directives/controls/grid/dataGrid';
import { Status } from './model/project/Status';
import { AdvancedSearch } from './model/search/advanced/AdvancedSearch';
import { BasicSearch } from './model/search/basic/BasicSearch';
import { SearchContext } from './model/search/ISearch';
import { Preferences } from './model/user/Preferences';
import { PreferenceService } from './services/user/PreferenceService';

const w = window as any;
w.app ??= {};

w.app.directives ??= {};
w.app.directives.controls ??= {};
w.app.directives.controls.DataGrid = DataGrid;

w.app.model ??= {};
w.app.model.project ??= {};
w.app.model.project.Status = Status;
w.app.model.search ??= {};
w.app.model.search.AdvancedSearch = AdvancedSearch;
w.app.model.search.BasicSearch = BasicSearch;
w.app.model.search.SearchContext = SearchContext;
w.app.model.user ??= {};
w.app.model.user.Preferences = Preferences;

w.app.services ??= {};
w.app.services.user ??= {};
w.app.services.user.PreferenceService = PreferenceService;
